module.exports = __webpack_public_path__ + "static/fonts/Robotolight.611ac98.woff";